module.exports = __webpack_public_path__ + "img/heart6.fbe3ea53.png";